import classNames from 'classnames';
import { EditWithAIWithModal } from '../EditWithAI';
import { Card } from '../RulesManager';

export interface EditWithAIManagerProps {
  onSaveData?: (text: string) => void;
  closeEditScreen?: () => void;
  open: boolean;
  removeExamples?: boolean;
  className?: string;
}

export const EditWithAIForm = ({
  onSaveData,
  open,
  closeEditScreen,
  removeExamples,
  className: extendClassName,
}: EditWithAIManagerProps) => {
  if (!open) return null;

  return (
    <Card className={classNames('', extendClassName)}>
      <Card.Content>
        <EditWithAIWithModal
          inputLabel="Find and Replace Using AI"
          onResponse={(prompt) => {
            onSaveData(prompt);
            return Promise.resolve();
          }}
          removeExamples={removeExamples}
          onClose={closeEditScreen}
        />
      </Card.Content>
    </Card>
  );
};
